import { createLoadingReducer } from './utils';

export default createLoadingReducer('CALCULATION_TYPES');
